<template>
  <div id="vendas-por-vendedor" style="line-height:17px!important;">
    
    <nav-menu></nav-menu>

    <header>
      <h5 class="w3-left w3-col s12 l12 w3-padding">
        <b>
          <i class="fa fa-tags"></i>
          <span> Verificar Vendas por Vendedor</span>
        </b>
      </h5>
    </header>

    <div class="w3-container" v-show="!mostrar_filtros">
      <div id="tipo_de_movimento"  class="w3-left w3-col s12 w3-block w3-padding-small">
        <strong class="w3-block">Tipo de movimento</strong>

        <div class="w3-col s11 m3 l2">
          <input 
            id="lbVendas"
            class="w3-radio" 
            v-model="tipo_movimento"
            type="radio"
            value="VEN"/>

          <label 
            for="lbVendas"  
            style="line-height: 43px; text-align: left">
            <span>Vendas</span>
          </label>
        </div>

        <div class="w3-col s11 m4 l4">
          <input 
            id="lbAcumulativos"
            class="w3-radio" 
            v-model="tipo_movimento"
            type="radio" 
            value="ACU"/>
          
          <label 
            for="lbAcumulativos"  
            style="line-height: 43px; text-align: left">
            <span>Acumulativos aberto</span>
          </label>
        </div>
      </div>

      <div 
        id="filtro_por_data" class="w3-left w3-col s12 w3-padding-small w3-block">
        <strong class="w3-block">Filtrar por data</strong>

        <div class="w3-col s11 m3 l2">
          <input id="lbfechamento" 
            type="radio" class="w3-radio" 
            v-model="tipo_filtro_data"
            value="FEC"
            @change="estado_data = 'Fechamento'"/>

          <label 
            style="line-height: 43px; text-align: left" 
            for="lbfechamento">
            <span>Fechamento</span>
          </label>
        </div>

        <div class="w3-col s11 m3 l2">
          <input
            id="lbrecebimento" 
            type="radio"
            class="w3-radio" 
            v-model="tipo_filtro_data"
            value="REC" 
            @change="estado_data = 'Recebimento'"/>
            
          <label 
            style="line-height: 43px; text-align: left"
            for="lbrecebimento">
            <span>Recebimento</span>
          </label>
        </div>
      </div>

      <div class="w3-padding-small">
        <strong 
          id="lbrecebimento"
          :class="getFiltroRapidoSelecionado(mes_atual)" 
          @click="filtroDataRapidoMesAtual()" 
          style="white-space: nowrap;">
          <i class="far fa-calendar-alt" v-show="mes_atual"></i>
          <span>Mês atual</span>
        </strong>

        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>

        <strong 
          id="lbrecebimento"
          :class="getFiltroRapidoSelecionado(ultimos_30dias)" 
          @click="filtroDataRapido30dias()" 
          style="white-space: nowrap;">
          <i class="far fa-calendar-alt" v-show="ultimos_30dias"></i> 
          <span>Últimos 30 dias</span>
        </strong>

        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>

        <strong 
          id="lbrecebimento"
          :class="getFiltroRapidoSelecionado(ultimos_45dias)" 
          @click="filtroDataRapido45dias()"
          style="white-space: nowrap;">
          <i class="far fa-calendar-alt" v-show="ultimos_45dias"></i>
          <span>Últimos 45 dias</span>
        </strong>

        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>

        <strong 
          id="lbrecebimento"
          :class="getFiltroRapidoSelecionado(personalizado)"
          @click="filtroDataRapidoPersonalizado()" 
          style="white-space: nowrap;">
          <i class="far fa-calendar-alt" v-show="personalizado"></i>
          <span>Definir período</span>
        </strong>
      </div>
      
      <div 
        id="lbinicio" 
        v-on:keyup.enter="buscarPedidos()"
        v-if="personalizado"
        class="w3-left w3-col m4 s12 l3 w3-padding-small w3-block">
        
        <strong>Data {{estado_data}} inicial</strong>
        <input
          class="w3-input w3-border"
          type="date"
          maxlength="10"
          v-model="data_inicial"
          @keypress="validarData(data_inicial)"/>
      </div>

      <div 
        id="lbfinal"
        v-on:keyup.enter="buscarPedidos()"
        v-if="personalizado" 
        class="w3-left w3-col m4 s12 l3 w3-padding-small w3-block">
        
        <strong >Data {{estado_data}} final</strong>
        <input
          class="w3-input w3-border"
          type="date"
          maxlength="10"
          v-model="data_final"
          @keypress="validarData(data_final)"/>
      </div>
  
      <div id="lbvendedor" class="w3-left w3-col s12 l6 w3-padding-small w3-block">
        <frame-vendedor
          ref="frVendedor"
          :somenteLeitura="bloquear_trocar_vendedor"
          @confirmar="adicionarVendedor"
          @limparDados="limparVendedor"
        />
      </div>
        
      <div id="lbpedido" class="w3-left w3-col m4 s12 l2 w3-padding-small w3-block">
        <strong class="w3-block">Pedido</strong>
        <input
          v-on:keyup.enter="buscarPedidos()" 
          id="lbpedido" 
          class="w3-input w3-border"
          @keypress="apenasNumeros()" 
          type="text"
          maxlength="10" 
          v-model="orcamento_id"
          placeholder="Cód."/>
      </div>
      
      <div id="lbdevolucao" class="w3-left w3-col m4 s12 l2 w3-padding-small w3-block">
        <strong class="w3-block">Devolução</strong>
        <input 
          v-on:keyup.enter="buscarPedidos()"
          id="lbdevolucao" 
          type="text"
          class="w3-input w3-border" 
          @keypress="apenasNumeros()" 
          maxlength="10"
          v-model="devolucao_id" 
          placeholder="Cód."/>
      </div> 

      <div id="lbturno" class="w3-left w3-col m4 s12 l2 w3-padding-small w3-block">
        <strong class="w3-block">Turno</strong>
        <input
          v-on:keyup.enter="buscarPedidos()"
          id="lbturno" 
          class="w3-input w3-border"
          type="text" 
          @keypress="apenasNumeros()"
          maxlength="10" 
          v-model="turno_id"
          placeholder="Cód."/>
      </div>
      
      <div id="lbcliente" class="w3-left w3-col s12 l6 w3-padding-small w3-block">
        <frame-cliente
          ref="frCliente"
          somenteLeitura="N"
          @confirmar="confirmarCliente"
          @limparDados="limparDadosCliente"
          :clienteSelecionado="cliente_selecionado"/>
      </div>
      
      <div
        class="w3-center texto-cinza w3-display-container w3-col s12 m12 w3-padding-24"
        style="text-align:right"
        v-cloak>
        <button
          class="w3-button w3-theme w3-col s12 m2 w3-display-middle w3-margin-top"
          v-on:click="buscarPedidos()"
          :disabled="processando">
          <span>Processar</span>
        </button>
      </div>
    </div>

    <div class="w3-panel w3-col" v-if="processando">
      <p class="w3-theme w3-card-2 w3-padding">
        <i class="fa fa-sync-alt w3-spin"></i>
        <span> Processando...</span>
      </p>
    </div>
    
    <div class="w3-container w3-col s12 " v-if="exibir_totalizador_filtros">
      <div class="w3-white w3-padding" style="width:100%;">
        <br v-show="mostrar_filtros" />
        <div class="w3-center">
          <button 
            class="btn-mix button-link w3-center" 
            style="font-size:25px;"
            @click="mostrar_filtros=true"
            v-show="!mostrar_filtros">
            <i class="fas fa-caret-down"></i>
          </button>
            
          <button
            class="btn-mix w3-button w3-white w3-border w3-mobile" 
            @click="mostrar_filtros=false"
            v-show="mostrar_filtros">
            <i class="fa fa-filter icone-vermelho"></i>
            Alterar filtros utilizados
          </button>
        </div>
      </div>

      <div class="w3-white" style="width:100%;" v-show="mostrar_filtros">
        <div class="w3-left w3-margin-top">
          <strong class="w3-col">Filtros utilizados:</strong>
          <ul class="w3-ul">
            <li
              :key="filtro.descricao"
              v-show="filtro.descricao"
              v-for="filtro in filtros_utilizados">
              <span>{{filtro.descricao}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div 
      class="w3-col" 
      v-show="(pedidos.length > 0) || (devolucoes.length > 0)">
      
      <div class="w3-padding-small">        
        <div class="w3-col l4 w3-padding-small">
          <button
            :class="getEstiloBotao(mostrar_grafico)"
            style="width: 100%; cursor:pointer; margin-top: 5px;"
            @click="mostrarOcultarGrafico()" 
            v-show="mostrar_filtros">
            <i class="fas fa-chart-line"></i>
            <span>Resumo</span>
          </button>
        </div>

        <div 
          class="w3-col l4 w3-padding-small" 
          v-show="pedidos.length > 0">
          <button
            :class="getEstiloBotao(mostrar_pedidos)"
            style="width: 100%; cursor:pointer; margin-top: 5px;"
            @click="mostrarOcultarPedidos()" 
            v-show="mostrar_filtros">
            <i class="fas fa-shopping-cart"></i>
            <span>Pedidos</span>
          </button>
        </div>

        <div class="w3-col l4 w3-padding-small" v-show="devolucoes.length > 0">
          <button
            :class="getEstiloBotao(mostrar_devolucoes)"
            style="width: 100%; cursor:pointer; margin-top: 5px;"
            @click="mostrarOcultarDevolucoes()"
            v-show="mostrar_filtros">
            <i class="fas fa-handshake-slash"></i>
            <span>Devoluções</span>
          </button>
        </div>
      </div>
    </div>

    <div 
      class="w3-container w3-margin-top"
      v-show="pedidos.length > 0 || devolucoes.length > 0">
      
      <div 
        v-if="mostrar_grafico" 
        id="graficos" 
        class="w3-animate-left"
        v-show="mostrar_filtros">  
        
        <VueApexCharts 
          type=bar height="350" 
          :options="chartOptions"
          :series="series">
        </VueApexCharts>

        <div 
          class="w3-center w3-col s12 w3-border w3-margin-top resultado-sintetico" 
          v-show="mostrar_filtros">
          
          <strong>
            <span>Qtd. pedidos: </span>
            <span class="texto-verde">{{totalizador_pedido.quantidade}}</span>
          </strong>
        </div>

        <div 
          class="w3-center w3-col s12 w3-border w3-margin-top resultado-sintetico" 
          v-show="mostrar_filtros">
          
          <strong>
            <span>Qtd. devoluções: </span>
            <span class="texto-vermelho">{{totalizador_devolucao.quantidade}}</span>
          </strong>
        </div>

        <div 
          class="w3-center w3-col s12 w3-border w3-margin-top resultado-sintetico"
          v-show="mostrar_filtros">
          
          <strong>
            <span>Total Pedidos: </span>
            <span class="texto-verde">R$ {{totalizador_pedido.total_liquido}}</span>
          </strong>
        </div>

        <div 
          class="w3-center w3-col s12 w3-border w3-margin-top resultado-sintetico" 
          v-show="mostrar_filtros">
          
          <strong>
            <span>Total Devoluções: </span>
            <span class="texto-vermelho">R$ {{totalizador_devolucao.total_liquido}}</span>
          </strong>
        </div>

        <div 
          class="w3-center w3-col s12 w3-border w3-margin-top resultado-sintetico  w3-margin-bottom" 
          v-show="mostrar_filtros">
          
          <strong v-if="parseFloat(totalizador_pedido.total_geral) > 0">
            <span>Total Geral: </span>
            <span class="texto-verde">R$ {{totalizador_pedido.total_geral}}</span>
          </strong>
          
          <strong v-else >
            <span>Total Geral: </span>
            <span class="texto-vermelho">R$ {{totalizador_pedido.total_geral}}</span>
          </strong>
        </div>
      </div>
      
      <div id="tabPedidos" v-if="mostrar_pedidos">
        <div 
          class="w3-card w3-padding-small w3-margin-top w3-container"
          style="border-radius: 15px;">
          
          <div class="w3-col s12 l3">
            <label>Qtd.pedidos: </label>
            <strong>
              <span class="texto-verde">{{totalizador_pedido.quantidade}}</span>
            </strong>
          </div>

          <div class="w3-col l3">
            <label>Vendas líquidas: </label>
            <strong class="totalizador-verde">R$ {{totalizador_pedido.total_liquido}}</strong>
          </div>

          <div class="w3-col l3" v-if="totalizador_pedido.total_sem_promocao">
            <label>Total sem promoção: </label>
            <strong class="totalizador-verde">R$ {{totalizador_pedido.total_sem_promocao}}</strong>
          </div>

          <div class="w3-col l3" v-if="totalizador_pedido.total_com_promocao">
            <label>Total com promoção: </label>
            <strong class="totalizador-verde">R$ {{totalizador_pedido.total_com_promocao}}</strong>
          </div>

          <div class="w3-col l3" v-if="totalizador_pedido.total_produtos">
            <label>Total produtos: </label>
            <strong class="totalizador-verde">R$ {{totalizador_pedido.total_produtos}}</strong>
          </div>

          <div class="w3-col l3" v-if="totalizador_pedido.total_geral_desconto">
            <label>Total descontos: </label>
            <strong class="totalizador-vermelho">
              R$ {{totalizador_pedido.total_geral_desconto}} ({{totalizador_pedido.perc_desconto}}%)
            </strong>
          </div>

          <div class="w3-col l3" v-if="totalizador_pedido.total_cred_manual_dev">
            <label>Total cred. manual dev.: </label>
            <strong class="totalizador-verde">R$ {{totalizador_pedido.total_cred_manual_dev}}</strong>
          </div>
          
          <div class="w3-col l3" v-if="totalizador_pedido.total_cred_manual_dev">
            <label>Total pedidos: </label>
            <strong class="totalizador-verde">R$ {{totalizador_pedido.total_liquido}}</strong>
          </div>
        </div>
        
        <div class="w3-mobile" v-show="pedidos" id="tabelaPedidos" >
          <table
            :class="
              'w3-table w3-border w3-bordered w3-centered w3-striped w3-white ' + 
              'w3-margin-top w3-margin-bottom w3-hide-small w3-hide-medium '">
            <thead>
              <tr>
                <th class="alinhamento-numero">Pedido</th>
                <th class="alinhamento-texto">Fechamento</th>
                <th class="alinhamento-texto">Recebimento</th>
                <th class="alinhamento-texto">Cliente</th>
                <th class="alinhamento-texto" >Vendedor</th>
                <th class="alinhamento-numero">Desconto</th>
                <th class="alinhamento-numero">Alteração (F5)</th>
                <th class="alinhamento-numero">Desconto</th>
                <th class="alinhamento-numero">Over price</th>
                <th class="alinhamento-numero">Valor</th>
                <th class="alinhamento-numero">Créd. manual</th>
                <th class="alinhamento-tipo">Tipo de entrega</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="label-clicavel"
                :key="pedido.id"
                v-for="pedido in pedidos"
                v-on:click="abrirDadosOrcamento(pedido.id, pedido.tipo_entrega_analitico)">

                <td class="alinhamento-centralizado" v-if="mostrar_aniversario_pedido == 'S'">
                  <i 
                    v-if="pedido.aniversariando == 'S'"
                    class="fa fa-birthday-cake titulo texto-vermelho">  
                  </i>
                </td>

                <td class="alinhamento-numero">{{pedido.id}}</td>
                <td class="alinhamento-texto">{{pedido.data_fechamento}}</td>
                <td class="alinhamento-texto">{{pedido.data_recebimento}}</td>
                <td class="alinhamento-texto">{{pedido.cliente_id}} - {{pedido.nome_cliente}}</td>
                
                <td class="alinhamento-texto" v-if="pedido.vendedor_id">
                  <span>{{pedido.vendedor_id}} - {{pedido.nome_vendedor}}</span>
                </td>
                
                <td class="alinhamento-texto" v-else if="pedido.vendedor_id"></td>

                <td class="alinhamento-numero">
                  <span v-if="pedido.valor_desconto">R$ {{pedido.valor_desconto}}</span>
                </td>
                
                <td class="alinhamento-numero">
                  <span v-if="pedido.valor_desconto_preco_manual">R$ {{pedido.valor_desconto_preco_manual}}</span>
                </td>
                
                <td class="alinhamento-numero">
                  <span v-if="pedido.percentual_desconto">{{pedido.percentual_desconto}}%</span>
                </td>

                <td class="alinhamento-numero">
                  <span v-if="pedido.valor_acrescimo_over_price">R$ {{pedido.valor_acrescimo_over_price}}</span>
                </td>

                <td class="alinhamento-numero">
                  <span v-if="pedido.valor_movimento">R$ {{pedido.valor_movimento}}</span>
                </td>
                
                <td class="alinhamento-numero">
                  <span v-if="pedido.valor_credito_manual">R$ {{pedido.valor_credito_manual}}</span>
                </td>
                
                <td 
                  :style="getCoresEntregas(pedido.tipo_entrega_analitico)" 
                  class="alinhamento-tipo">
                  <span>{{pedido.tipo_entrega_analitico}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="w3-hide-large">
          <div
            class="w3-show card-informacoes w3-border w3-margin-top"
            :key="pedido.id"
            v-for="pedido in pedidos">

            <div class="w3-col s12 texto-vermelho">
              <strong>{{pedido.id}}</strong>
            </div>

            <div class="w3-col s12  texto-verde">
              <strong>R$ {{pedido.valor_movimento}}</strong>
            </div>

            <div class="w3-col s12 ">
              <legenda>
                <div>Cliente</div>
                <i slot="referencia" class="fa fa-user-tag texto-vermelho"></i>
              </legenda>
              <strong>&nbsp;{{pedido.cliente_id}} - {{pedido.nome_cliente}}</strong>
            </div>

            <div class="w3-col s12"  v-if="pedido.vendedor_id" >
              <legenda>
                <div>Nome do vendedor</div>
                <i slot="referencia" class="fa fa-user-tie texto-vermelho"></i>
              </legenda>
              <label>&nbsp;&nbsp;{{pedido.vendedor_id}} - {{pedido.nome_vendedor}}</label>
            </div>

            <div 
              class="w3-col s12" 
              v-if="(
                pedido.data_recebimento &&
                (pedido.data_recebimento != pedido.data_fechamento)
              )">

              <label>Fechamento: </label>
              <strong>{{pedido.data_fechamento}}</strong>
            </div>

            <div
              class="w3-col s12" 
              v-if="(
                pedido.data_recebimento && 
                pedido.data_recebimento && 
                (pedido.data_recebimento == pedido.data_fechamento)
              )">
              
              <label>{{estado_data}}</label>
              <strong>{{pedido.data_fechamento}}</strong>
            </div>

            <div
              class="w3-col s12" 
              v-if="(
                pedido.data_recebimento && 
                (pedido.data_recebimento != pedido.data_fechamento)
              )">
              
              <label>Recebimento: </label>
              <strong>{{pedido.data_recebimento}}</strong>
            </div>

            <div class="w3-col s12" v-if="pedido.valor_desconto">
              <label>Desconto: </label>
              <strong>R$ {{pedido.valor_desconto}}</strong>
            </div>

            <div
              class="w3-col s12"
              v-if="pedido.valor_desconto_preco_manual">
              <label>Alteração (F5):</label>
              <strong>R$ {{pedido.valor_desconto_preco_manual}}</strong>
            </div>

            <div class="w3-col s12" v-if="pedido.percentual_desconto">
              <label>Desconto:</label>
              <strong>{{pedido.percentual_desconto}}%</strong>
            </div>

            <div class="w3-col s12" v-if="pedido.valor_acrescimo_over_price">
              <label>Over price:</label>
              <strong>R$ {{pedido.valor_acrescimo_over_price}}</strong>
            </div>

            <div class="w3-col s12" v-if="pedido.valor_credito_manual">
              <label>Créd. manual:</label>
              <strong>R$ {{pedido.valor_credito_manual}}</strong>
            </div>

            <div class="w3-col s12">
              <legenda>
                <div>Tipo de entrega</div>
                <i slot="referencia" class="fas fa-shipping-fast texto-vermelho"></i>
              </legenda>
              <label 
                :style="getCoresEntregas(pedido.tipo_entrega_analitico)">
                <span>&nbsp;&nbsp;{{pedido.tipo_entrega_analitico}}</span>
              </label>
            </div>
            
            <div 
              class="w3-center" 
              @click="abrirDadosOrcamento(pedido.id, pedido.tipo_entrega_analitico)">
              <button class="w3-button w3-theme"> 
                <i class="fas fa-search"></i>
              </button>
            </div>
          
          </div>
        </div>
  
        <dados-orcamento
          :orcamento_dados="orcamento_detalhe"
          v-if="mostrarModalDadosOrcamento"
          @close="mostrarModalDadosOrcamento = false">
        </dados-orcamento>
      </div>
    </div>

    <div class="w3-container w3-margin-top">
      <div id="tabDevolucoes" v-if="mostrar_devolucoes">
        <div 
          class="w3-card w3-padding-small w3-margin-top w3-container"
          style="border-radius: 15px;">

          <div class="w3-col l3">
            <label>Qtd. devoluções: </label>
            <strong>
              <span style="color:red;">{{totalizador_devolucao.quantidade}}</span>
            </strong>
          </div>

          <div class="w3-col l3">
            <label>Total líquido dev.: </label>
            <strong style="color:red;">R$ {{totalizador_devolucao.total_liquido}} 
              <strong v-if="totalizador_devolucao.percentual_geral_devolucao">
                ({{totalizador_devolucao.percentual_geral_devolucao.replace(' ','')}})
              </strong>
            </strong>
          </div>

          <div class="w3-col l3">
            <label>Total créd. manual dev. : </label>
            <strong style="color:red;">R$ {{totalizador_pedido.total_cred_manual_dev}}</strong>
          </div>
        </div>
        
        <div class="w3-responsive" v-show="devolucoes" id="tabelaDevolucoes">
          <table :class="
            'w3-table-all w3-border w3-bordered w3-centered w3-striped w3-white w3-margin-top ' + 
            'w3-margin-bottom w3-hide-small w3-hide-medium'">

            <thead>
              <tr>
                <th
                  class="alinhamento-centralizado w3-centered"
                  v-if="mostrar_aniversario_devolucao == 'S'">
                  <span>Aniversário</span>
                </th>

                <th class="alinhamento-numero">Devolução</th>
                <th class="alinhamento-texto">Fechamento</th>
                <th class="alinhamento-texto">Recebimento</th>
                <th class="alinhamento-texto">Cliente</th>
                <th class="alinhamento-texto" >Vendedor</th>
                <th class="alinhamento-numero">Desconto</th>
                <th class="alinhamento-numero">Alteração (F5)</th>
                <th class="alinhamento-numero">Desconto</th>
                <th class="alinhamento-numero">Over price</th>
                <th class="alinhamento-numero">Valor</th>
                <th class="alinhamento-numero">Créd. manual</th>
                <th class="alinhamento-tipo">Tipo de entrega</th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="label-clicavel"
                :key="devolucao.id"
                v-for="devolucao in devolucoes"
                v-on:click="abrirDadosDevolucao(devolucao.id)">

                <td class="alinhamento-centralizado" v-if="mostrar_aniversario_devolucao == 'S'">
                  <i
                    v-if="devolucao.aniversariando == 'S'"
                    class="fa fa-birthday-cake titulo texto-vermelho">
                  </i>
                </td>

                <td class="alinhamento-numero">{{devolucao.id}}</td>
                <td class="alinhamento-texto">{{devolucao.data_fechamento}}</td>
                <td class="alinhamento-texto">{{devolucao.data_recebimento}}</td>
                
                <td class="alinhamento-texto">
                  <span>{{devolucao.cliente_id}} - {{devolucao.nome_cliente}}</span>
                </td>
                
                <td
                  class="alinhamento-texto" 
                  v-if="devolucao.vendedor_id">
                  <span>{{devolucao.vendedor_id}} - {{devolucao.nome_vendedor}}</span>
                </td>

                <td class="alinhamento-texto" v-else if="devolucao.vendedor_id"></td>
                
                <td class="alinhamento-numero">
                  <span v-if="devolucao.valor_desconto">R$ {{devolucao.valor_desconto}}</span>
                </td>
                
                <td class="alinhamento-numero">
                  <span v-if="devolucao.valor_desconto_preco_manual">
                    <span>R$ {{devolucao.valor_desconto_preco_manual}}</span>
                  </span>
                </td>

                <td class="alinhamento-numero">
                  <span v-if="devolucao.percentual_desconto">
                    <span>{{devolucao.percentual_desconto}} %</span>
                  </span>
                </td>

                <td class="alinhamento-numero">
                  <span v-if="devolucao.valor_acrescimo_over_price">
                    <span>R$ {{devolucao.valor_acrescimo_over_price}}</span>
                  </span>
                </td>

                <td class="alinhamento-numero">
                  <span v-if="devolucao.valor_movimento">R$ {{devolucao.valor_movimento}}</span>
                </td>

                <td class="alinhamento-numero">
                  <span v-if="devolucao.valor_credito_manual">
                    <span>R$ {{devolucao.valor_credito_manual}}</span>
                  </span>                  
                </td>

                <td 
                  :style="getCoresEntregas(devolucao.tipo_entrega_analitico)" 
                  class="alinhamento-tipo">
                  <span>{{devolucao.tipo_entrega_analitico}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      
        <div class="w3-hide-large" v-if="mostrar_devolucoes"> 
          <div
            class="w3-show card-informacoes w3-border w3-margin-top"
            :key="devolucao.id"
            v-for="devolucao in devolucoes">
            
            <div class="w3-col s12" v-if="devolucao.aniversariando == 'S'">
              <label>Aniversário: </label>
              <i class="fa fa-birthday-cake titulo texto-vermelho"></i>
            </div>

            <div class="w3-col s12">
              <label>Devolução: </label>
              <strong class="texto-vermelho">{{devolucao.id}}</strong>
            </div>

            <div class="w3-col s12">
              <strong class="texto-verde">R$ {{devolucao.valor_movimento}}</strong>
            </div>

            <div class="w3-col s12">
              <legenda>
                  <div>Cliente </div>
                  <i slot="referencia" class="fa fa-user-tag texto-vermelho"></i>
              </legenda>
              <strong>&nbsp;{{devolucao.cliente_id}} - {{devolucao.nome_cliente}}</strong>
            </div>

            <div class="w3-col s12"  v-if="devolucao.vendedor_id" >
              <legenda>
                <div>Nome do vendedor</div>
                <i slot="referencia" class="fa fa-user-tie texto-vermelho"></i>
              </legenda>
              <strong>&nbsp;&nbsp;{{devolucao.vendedor_id}} - {{devolucao.nome_vendedor}}</strong>
            </div>

            <div class="w3-col s12" v-if="tipo_filtro_data == 'FEC'">
              <label>Fechamento: </label>
              <strong>{{devolucao.data_fechamento}}</strong>
            </div>

            <div class="w3-col s12" v-if="tipo_filtro_data == 'REC'">
              <label v-if="devolucao.data_recebimento">Recebimento: </label>
              <strong>{{devolucao.data_recebimento}}</strong>
            </div>

            <div class="w3-col s12" v-if="devolucao.valor_desconto">
              <label>Desconto: </label>
              <strong>{{devolucao.valor_desconto}}%</strong>
            </div>

            <div
              class="w3-col s12"
              v-if="devolucao.valor_desconto_preco_manual" >
              <label>Alteração (F5): </label>
              <strong>R${{devolucao.valor_desconto_preco_manual}}</strong>
            </div>

            <div class="w3-col s12" v-if="devolucao.percentual_desconto">
              <label>Desconto: </label>
              <strong>{{devolucao.percentual_desconto}}%</strong>
            </div>

            <div
              class="w3-col s12"
              v-if="devolucao.valor_acrescimo_over_price">
              <label>Over price: </label>
              <strong>R${{devolucao.valor_acrescimo_over_price}}</strong>
            </div>

            <div class="w3-col s12" v-if="devolucao.valor_credito_manual">
              <label>Créd. manual: </label>
              <strong>R${{devolucao.valor_credito_manual}}</strong>
            </div>

            <div class="w3-col s12">
              <legenda>
                <div>Tipo de entrega</div>
                <i slot="referencia" class="fas fa-shipping-fast texto-vermelho"></i>
              </legenda>

              <strong 
                :style="getCoresEntregas(devolucao.tipo_entrega_analitico)">
                <span>&nbsp;&nbsp;{{devolucao.tipo_entrega_analitico}}</span>
              </strong>              
            </div>
            
            <div 
              class="w3-center" 
              @click="abrirDadosDevolucao(devolucao.id)">
              <button class="w3-button w3-theme"> 
                <i class="fas fa-search"></i>
              </button>
            </div>
  
          </div>
        </div>

        <dados-devolucao
          :devolucao_dados="devolucao_detalhe"
          v-if="mostrarModalDadosDevolucao"
          @close="mostrarModalDadosDevolucao = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import store from '@/ambiente/store'
import VueNumeric from 'vue-numeric'
import NavMenu from '@/components/Menu'
import VueApexCharts from 'vue-apexcharts'
import Legenda from '@/components/Legendas'
import RSessao from '@/components/Rest/RSessao'
import FrameCliente from '@/components/Frames/FrameCliente'
import formatarValorMixin from '@/mixins/formatarValorMixin'
import FrameVendedor from '@/components/Frames/FrameVendedor'
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import DadosOrcamento from '@/components/Orcamentos/DadosOrcamento'
import DadosDevolucao from '@/components/Orcamentos/DadosDevolucao'
import RRelacaoVendasPorVendedor from '@/components/Rest/RRelacaoVendasPorVendedor.js'

export default {
  name: "VendasPorVendedor",

  components: {
    NavMenu,
    FrameVendedor,
    FrameCliente,
    DadosOrcamento,
    DadosDevolucao,
    Legenda,
    VueApexCharts,
    VueNumeric,
  },

  mixins:[formatarValorMixin],

  data() {
    return {
      data_invalida: false,
      mostrar_devolucoes: false,
      mostrar_pedidos: false,
      mostrar_grafico: false,
      estado_data: 'Fechamento',
      api: process.env.API,
      processando: false,
      ultimos_45dias: false,
      ultimos_30dias: false,
      mes_atual: true,
      personalizado: false,
      data_inicial: '',
      data_final: '',
      orcamento_id: '',
      devolucao_id: '',
      errors: [],
      turno_id: '',
      tipo_movimento: 'VEN',
      tipo_filtro_data: 'FEC',
      mostrar_filtros: false,
      pedidos: [],
      devolucoes: [],
      filtros_utilizados: [],
      bloquear_trocar_vendedor: 'N',
      orcamento_detalhe: {},
      devolucao_detalhe: {},
      chartOptions: {}, 
      series: [], 
      mostrarModalDadosOrcamento: false,
      mostrarModalDadosDevolucao: false,
      mostrar_aniversario_pedido: '',
      mostrar_aniversario_devolucao: '',
      exibir_totalizador_filtros: false,

      vendedor_selecionado: {},

      cliente_selecionado: {
        cadastro_id: '',
        nome_razao_social: ''
      },

      totalizador_pedido: {
        quantidade: '',
        total_liquido: ''
      },

      totalizador_devolucao: {
        quantidade: '',
        total_liquido: '',
        total_geral:''
      }
    };
  },
  
  methods: {
    validarData(data) {
      let data_entrada = new Date(Date.parse(data)).toLocaleDateString();
      return data_entrada;
    },
    
    apenasNumeros(string) {
      let evento = string || window.event;
      let key = evento.keyCode || evento.which;
      key = String.fromCharCode(key);

      let regex = /^[0-9.]+$/;

      if (!regex.test(key)) {
        evento.returnValue = false;
        
        if (evento.preventDefault) {
          evento.preventDefault();
        }
      }
    },
    
    getEstiloBotao(mostrar_filtros) {
      if (mostrar_filtros) {
        return 'ativo';
      }
      else {
        return 'w3-theme w3-button';
      }
    },
    
    
    getCoresEntregas(tipo_entrega){
      if (tipo_entrega == "No ato") {
        return 'color:#4650ff';
      }

      if (tipo_entrega == "Entregar"){
        return 'color:#ff79ff';
      }

      if (tipo_entrega == "Ret. lojas rede") {
        return 'color:#92a350';
      }
    },

    verificarDados() {
      if (this.orcamento_id.length > 10) {
        Biblioteca.exclamar('Código de orçamento inválido!');
        return false;
      }

      if (this.devolucao_id.length > 10) {
        Biblioteca.exclamar('Código de devolução inválido!');
        return false;
      }

      if (this.turno_id.length > 10) {
        Biblioteca.exclamar('Código de turno inválido!');
        return false;
      }

      if (!Biblioteca.validarPeriodo(this.data_inicial, this.data_final)) {
        /* a função validarPeriodo já retorna a mensagem */
        return false;
      }

      return true;
    },
  
    getFiltroRapidoSelecionado(selecionado){
      let retorno = 'opcao-data';
      if (selecionado) {
        retorno = 'texto-vermelho w3-text';
      }

      return retorno
    },

    mostrarOcultarDevolucoes() {
      this.mostrar_devolucoes = true;
      this.mostrar_grafico = false;
      this.mostrar_pedidos = false;
    },

    mostrarOcultarPedidos() {
      this.mostrar_pedidos = true;
      this.mostrar_grafico = false;
      this.mostrar_devolucoes = false;
    },

    mostrarOcultarGrafico() {
      this.mostrar_grafico =  true;
      this.mostrar_pedidos = false;
      this.mostrar_devolucoes = false;
    },

    criarGrafico(totalizador_devolucao, totalizador_pedido) {
      const c_cor_vendas = '#0fdbac';
      const c_cor_evolucoes = '#db0f49';
      const c_cor_venda_liquida = '#5e49e6';
      const c_cor_previsao = '#66ccff';

      let CoresVendasDev = [c_cor_vendas, c_cor_evolucoes];
      
      if (this.mostrar_previsao){
        CoresVendasDev.push(c_cor_previsao);
      }

      let total_vendas = this.Valor(totalizador_pedido.total_liquido);
      let total_devolvido = this.Valor(totalizador_devolucao.total_liquido);
      let total_giro = this.Valor(totalizador_pedido.total_geral);

      this.series = [{
        name: 'Valor',
        data: [total_vendas, total_devolvido]
      }],

      this.chartOptions = {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          }
        },

        colors: CoresVendasDev,
        
        dataLabels: {
          enabled: true,          
          formatter: function (val) {
            return "R$"+nPadrao(val,2)
          },
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: 10,
                offsetY: 0
              }
            }
          }
        ],

        plotOptions: {
          bar: {
            horizontal: false,
            distributed: true,
          },
        },
        
        legend: {
          position: 'center',
          offsetY: 30
        },

        fill: {
          opacity: 1
        },

        title: {
          text: undefined
        },

        xaxis: {            
          categories: ['Vendas', 'Devoluções'],  
        },

        yaxis: {
          show: false,
          enabled: false,
          title: {
            text: undefined
          },
        },

        tooltip: {
          position: 'center',
          categories:['Vendas', 'Devoluções'],
          y: {
            formatter: function(val){
              return "R$"+ nPadrao(val, 2)
            }
          }
        },
      
        fill: {
          opacity: 1
        },

        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        }       
      }

      this.mostrarOcultarGrafico()
    },
    
    async buscarUsuarioLogado() {
      if (await !RSessao.carregouSessao()) {
        await RSessao.buscarDadosCarregarSessao(this.axios);
      }
      
      let data =  JSON.parse(JSON.stringify(store.state.usuario_logado));

      this.bloquear_trocar_vendedor = 'N';
      if (data.cargo_id == 2){
        this.bloquear_trocar_vendedor = 'S';      
      }
      
      if (data.cargo_id == 2) {
        await this.$refs.frVendedor.inserirDadoPorChave(data.funcionario_id);
      }
    },

    verificarDadosCliente() {
      return true;
    },

    abrirDadosOrcamento(orcamento_id, tipo_entrega) {
      if (tipo_entrega == 'Acumulativo') {
        Biblioteca.exclamar('A visualização de dados do acumulativo não está disponível!');
        return;
      }

      this.orcamento_detalhe = orcamento_id;
      this.mostrarModalDadosOrcamento = !this.mostrarModalDadosOrcamento;
    },

    abrirDadosDevolucao(devolucao_id) {
      this.devolucao_detalhe = devolucao_id;
      this.mostrarModalDadosDevolucao = !this.mostrarModalDadosDevolucao;
    },

    toLimit(parametros = "") {
      return parametros = parametros.substring(0,9);
    },

    limitarCaracteres(max) {
      if(max > 999999999999) {
        return max = 0;
      }
    },

    async buscarPedidos() {
      try {

        if (!this.verificarDados()) {
          return;
        }
        
        this.pedidos = [];
        this.devolucoes = [];
        this.filtros_utilizados = [];

        this.processando = true;
        this.exibir_totalizador_filtros = false;
        
        let parametros = {
          data_inicial: Biblioteca.fData(this.data_inicial),
          data_final: Biblioteca.fData(this.data_final),
          orcamento_id: this.orcamento_id,
          devolucao_id: this.devolucao_id,
          turno_id: this.turno_id,
          tipo_data: this.tipo_filtro_data,
          vendedor_id: this.vendedor_selecionado.funcionario_id,
          nome_vendedor: this.vendedor_selecionado.nome,
          cliente_id: this.cliente_selecionado.cadastro_id,
          nome_cliente: this.cliente_selecionado.nome_razao_social,
          tipo_movimento: this.tipo_movimento,
          tipo_filtro_data:this.tipo_filtro_data
        }
      
        if (this.orcamento_id) {
          this.mostrar_grafico = false;
          this.mostrar_pedidos = true;
          this.mostrar_devolucoes = false;
        }

        if (this.devolucao_id) {
          this.mostrar_grafico = false;
          this.mostrar_pedidos = false;
          this.mostrar_devolucoes = true;
        }

        let retorno = await RRelacaoVendasPorVendedor.buscarRelacaoVendasPorVendedor(
          this.axios,
          parametros
        );

        if (retorno.houve_erro == 'S') {
          throw new Error(retorno.mensagem);
        }

        this.processando = false;
        this.mostrar_filtros = false;
        this.pedidos = retorno.dados.pedidos;
        this.devolucoes = retorno.dados.devolucoes;
        this.filtros_utilizados = retorno.dados.filtros_utilizados;
        this.totalizador_pedido = retorno.dados.totalizador_pedido;
        this.totalizador_devolucao = retorno.dados.totalizador_devolucao;
        this.mostrar_aniversario_pedido = retorno.dados.mostrar_aniversario_pedido;
        this.mostrar_aniversario_devolucao = retorno.dados.mostrar_aniversario_devolucao;
        
        this.mostrar_filtros = true;
        this.exibir_totalizador_filtros = true;
        this.criarGrafico(this.totalizador_devolucao, this.totalizador_pedido);
      } 
      catch (error) {
        this.processando = false;
        Biblioteca.exclamar(error.message);
      }
    },

    limparVendedor() {
      this.vendedor_selecionado = {};
    },

    limparDadosCliente() {
      this.cliente_selecionado = {};
    },

    adicionarVendedor(vendedor) {
      this.vendedor_selecionado = Object.assign({}, vendedor);
    },
    
    confirmarCliente(cliente) {
      this.cliente_selecionado = cliente;
    },

    dateToString(dia, mes, ano) {
      return ano + "-" + mes.padStart(2, "0") + "-" + dia.padStart(2, "0");
    },
  
    filtroDataRapido30dias(){
      this.personalizado = false;
      this.mes_atual = false;
      this.ultimos_45dias = false;
      this.ultimos_30dias = true;
      this.data_inicial = moment().subtract('days', 30).format('YYYY-MM-DD');
      
      this.data_final = this.dateToString(
        new Date().getDate().toString(),
        (new Date().getMonth() + 1).toString(),
        new Date().getFullYear().toString()
      );
    },

    filtroDataRapido45dias(){
      this.personalizado = false;
      this.mes_atual = false;
      this.ultimos_45dias = true;
      this.ultimos_30dias = false;
      this.data_inicial = moment().subtract('days', 45).format('YYYY-MM-DD');
      
      this.data_final = this.dateToString(
        new Date().getDate().toString(),
        (new Date().getMonth() + 1).toString(),
        new Date().getFullYear().toString()
      );
    },

    filtroDataRapidoMesAtual(){
      this.personalizado = false;
      this.mes_atual = true;
      this.ultimos_45dias = false;
      this.ultimos_30dias = false;
      
      this.data_inicial = this.dateToString(
        "01",
        (new Date().getMonth() + 1).toString(),
        new Date().getFullYear().toString()
      );
      
      this.data_final = this.dateToString(
        new Date().getDate().toString(),
        (new Date().getMonth() + 1).toString(),
        new Date().getFullYear().toString()
      );
    },

    filtroDataRapidoPersonalizado() {
      this.personalizado = !this.personalizado;

      if (this.personalizado) {
        this.mes_atual = false;
      }
      else {
        this.mes_atual = true
        this.filtroDataRapidoMesAtual()
      }

      this.ultimos_45dias = false;
      this.ultimos_30dias = false;
    }  
  },

  created() { 
    this.buscarUsuarioLogado();
    this.data_inicial = this.dateToString(
      "01",
      (new Date().getMonth() + 1).toString(),
      new Date().getFullYear().toString()
    );

    this.data_final = this.dateToString(
      new Date().getDate().toString(),
      (new Date().getMonth() + 1).toString(),
      new Date().getFullYear().toString()
    );
  }
}
</script>

<style scoped>
  .titulo {
    border-bottom: 1px solid #8d1007;
    font-size: 22px;
  }

  .card-item {
    margin-top: 0 !important;
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-radius: 15px;
    float: left;
    padding: 7px;
    cursor: pointer;
    transition: 0.2s;
    width: 100%;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
  }

  .card-informacoes-selecionado {
    border-left-color: #a20000 !important;
  }

  .card-informacoes:hover {
    background: #eeeeee;
  }
  
  .texto-verde{
    color: green;
  }
  
  .ativo{
    position:relative;
    top:5px;
    box-shadow:none;
    background-color:#f3f3f3!important;
    color:black;
    border-radius: 10px;
    height: 40px;
    outline:none
  }
  
  .botao-quadrado{
    background: #f3f3f3 !important;
    color:black;
  }
  
  .botao-quadrado:hover{
    background: grey !important;
  }
  
  .resultado-sintetico{
    border-radius: 25px;
    box-shadow: #f3f3f3 0px 5px 5px 0px;
  }

  .opcao-data {
    text-decoration: underline; 
    cursor: pointer;
    white-space: nowrap;
    font-style: none;
    font-weight: normal;
  }

  .totalizador-verde {
    color:green; 
    border-radius: 15%;
  }

  .totalizador-vermelho {
    color:red; 
    border-radius: 15%;
  }
</style>


// WEBPACK FOOTER //
// src/components/VendasPorVendedor.vue